import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ADMIN_PASSWORD = 'Leadzai2022*';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Verificar se user está autenticado
    if (!user) {
      setError('Precisa de estar autenticado para aceder ao painel admin');
      return;
    }

    // Verificar se é admin
    if (!user.isAdmin) {
      setError('Acesso negado: não tem permissões de administrador');
      return;
    }

    // Verificar password
    if (password !== ADMIN_PASSWORD) {
      setError('Password incorreta');
      return;
    }

    // Guardar sessão admin
    sessionStorage.setItem('admin_authenticated', 'true');
    navigate('/backoffice');
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md border border-primary/10">
        <div className="flex items-center justify-center mb-8">
          <img src="/fiscobem.svg" alt="fiscobem" className="h-10" />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">Painel Admin</h2>
        <p className="text-gray-600 mb-6 text-center">
          Acesso restrito a administradores
        </p>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-800">{error}</p>
          </div>
        )}

        {!user && (
          <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-sm text-yellow-800">
              Precisa de <a href="/login" className="underline font-medium">fazer login</a> primeiro
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Password Admin
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
              placeholder="••••••••"
              disabled={!user}
            />
          </div>

          <button
            type="submit"
            disabled={!user}
            className="w-full py-3 bg-gradient-primary text-white font-semibold rounded-lg hover:shadow-lg hover:-translate-y-0.5 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Entrar no Admin
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-gray-600">
          <button onClick={() => navigate('/dashboard')} className="text-primary hover:underline font-medium">
            Voltar ao Dashboard
          </button>
        </p>
      </div>
    </div>
  );
};

export default AdminLoginPage;